module.exports = __webpack_public_path__ + "static/media/slider3.81a60dce.png";